import { Mailroom } from '@apiContract';

import { getDateFromMinutesOffset } from '@utils/time';

const defaultConfiguration = {
  available: false,
  openDate: 'Unknown',
  closeDate: 'Unknown',
  openMinutes: 0,
  closeMinutes: 0,
};

export const useGetData = (mailroom?: Mailroom) => {
  const getMailRoomWorkingHours = (date: Date | undefined | null) => {
    if (!date) return defaultConfiguration;

    const currentWeekday = date.getDay();
    const currentActiveSpan = mailroom?.hoursOfOperation?.activeSpans?.find(
      (activeSpan) => activeSpan.dayOfWeek === currentWeekday,
    );
    if (!currentActiveSpan) return defaultConfiguration;

    return {
      available: true,
      openDate: getDateFromMinutesOffset(currentActiveSpan.open),
      closeDate: getDateFromMinutesOffset(currentActiveSpan.close),
      openMinutes: currentActiveSpan.open,
      closeMinutes: currentActiveSpan.close,
    };
  };

  return { getMailRoomWorkingHours };
};
